import { UserType } from "@shared/types";
import React, { useEffect, useState } from "react";
import { Avatar, AvatarGroup } from "@mui/material";
import userAvatarChecker from "@shared/UserAvatarChecker";
import { prepareAvatarContent } from "../../Components/UserAvatar/UserAvatarFactory";
import { avatarFallbackColorSelector } from "@shared/Avatar/AvatarFallbackColorSelector";

export function StackedAvatars({ users }: { users: UserType[] }) {
    const [avatarMap, setAvatarMap] = useState(new Map());

    useEffect(() => {
        setAvatarMap(new Map(users.map((user) => [user.uuid, user])));
    }, [setAvatarMap, users]);

    return (
        <AvatarGroup
            max={10}
            sx={{
                "& .MuiAvatar-root": {
                    border: "1px solid #FFF",
                    marginLeft: "-6px",
                    ".MuiSvgIcon-root": {
                        fontSize: "1.025rem",
                    },
                },
            }}
        >
            {[...avatarMap]
                .slice(0, 3)
                .map(([key, { avatar, uuid, gender }]) => {
                    return (
                        <Avatar
                            key={key}
                            src={avatar}
                            onError={() => userAvatarChecker(avatar, uuid)}
                        >
                            {prepareAvatarContent(
                                avatarFallbackColorSelector(uuid),
                                gender,
                            )}
                        </Avatar>
                    );
                })}
        </AvatarGroup>
    );
}
